import { render, staticRenderFns } from "./whatsapp-cloud.vue?vue&type=template&id=3ecf6c0b"
import script from "./whatsapp-cloud.vue?vue&type=script&lang=js"
export * from "./whatsapp-cloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports